<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M32 5H9.2C6.9 5 5 6.8 5 8.9v30.2C5 41.2 6.9 43 9.2 43h8.5v-6.8c0-3.5 2.7-6.2 6.2-6.3-.9-1.4-1.4-3.1-1.4-4.9 0-5.2 4.2-9.5 9.5-9.5 1.5 0 2.8.3 4.1.9V8.9C36.1 6.8 34.2 5 32 5zM17.3 19.9h-6.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h6.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm8-5.9H10.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h14.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M39.9 32.7h-5.6v-2.9c.4-.2.7-.3 1-.6.1-.1.2-.1.3-.2l.1-.1c.2-.2.5-.4.7-.6 1-1.1 1.6-2.6 1.6-4.1 0-1.9-.9-3.6-2.3-4.7-1.1-.9-2.5-1.4-4-1.4-3.4 0-6.3 2.7-6.3 6.1 0 2.1 1 3.9 2.7 5.1.3.2.7.4 1.1.6v2.9h-5.6c-1.8 0-3.1 1.3-3.1 3v3.4H43v-3.3c0-1.9-1.4-3.2-3.1-3.2zm-19.4 7.8V43H43v-2.5H20.5z" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
